import React from 'react'
import PropTypes from 'prop-types'

import { AppWrapper, Button, Text } from 'passiv-components'

const EmailUpdate = ({ loading, title, text, onClickButton, onBack }) => {
  return (
    <AppWrapper
      dataContainer="email-update"
      titleHeader="PassivLiving Email Change Confirmation"
      loading={loading}
      onBack={onBack}
    >
      <Text type="title" className="p-4 text-center">
        {title}
      </Text>
      <Text className="max-w-40 m-auto p-4 text-center">{text}</Text>
      <Button name="visit-portal" onClick={onClickButton} className="m-auto">
        <Text>{'Visit PassivLiving Portal >'}</Text>
      </Button>
    </AppWrapper>
  )
}

EmailUpdate.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  loading: PropTypes.bool,
  onBack: PropTypes.func
}

export default EmailUpdate
